import { Component, OnInit } from '@angular/core';
import { FormGroup , FormBuilder, Validators} from '@angular/forms';
import { UserService } from 'src/app/_services';
import { User } from 'src/app/_models';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
declare const $: any;

@Component({
  selector: 'app-change-password-modal',
  templateUrl: './change-password-modal.component.html',
  styleUrls: ['./change-password-modal.component.css']
})

export class ChangePasswordModalComponent implements OnInit {

  public submitted : boolean;
  public loading : boolean;
  public changePasswordForm : FormGroup;
  public user: User;


  constructor(
    private formBuilder: FormBuilder,
    private users : UserService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) { 
    this.users.editingUser.subscribe(user => this.user = user);
  }

  public get f () {
    return this.changePasswordForm.controls;
  }

  ngOnInit() {

    this.submitted = false;
    this.loading = false;
    
    this.changePasswordForm = this.formBuilder.group({
      password: ['', [Validators.required,  Validators.minLength(4), Validators.maxLength(10)]],
      verifyPassword: [''],
    },{validator: [this.checkPasswords] });
    
  }

  
  checkPasswords(group: FormGroup) {
    let pass = group.controls.password.value;
    let confirmPass = group.controls.verifyPassword.value;

    return pass === confirmPass ? null : { notSamePassword: true }     
  }
  
  onSubmitChangePasswordForm(){
    
    this.submitted = true;

    if (this.changePasswordForm.invalid){
      return ;
    }

    this.user.password = this.f.password.value;
    this.loading = true;

        
    this.users.changePassword(this.user).subscribe(
      result => {
        $("#modal-canvi-contrasenya").modal('hide');
        this.submitted = false;
        this.loading = false;
        this.f.password.reset();
        this.f.verifyPassword.reset();
      }, 
      error =>{
        this.submitted = false;
        this.loading = false;
        this.f.password.reset();
        this.f.verifyPassword.reset();
  
      }
    );

  }

}
